import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import { green, red, blue } from '@mui/material/colors';

export const OpenSwitch = styled(Switch)({
  '& .MuiSwitch-switchBase': {
    color: green[300],
    '&.Mui-checked': {
      color: green[500],
    },
    '&.Mui-checked + .MuiSwitch-track': {
      backgroundColor: green[500],
    },
  },
});

export const NoStatusSwitch = styled(Switch)({
  '& .MuiSwitch-switchBase': {
    color: red[300],
    '&.Mui-checked': {
      color: red[500],
    },
    '&.Mui-checked + .MuiSwitch-track': {
      backgroundColor: red[500],
    },
  },
});

export const ClosedSwitch = styled(Switch)({
  '& .MuiSwitch-switchBase': {
    color: blue[300],
    '&.Mui-checked': {
      color: blue[500],
    },
    '&.Mui-checked + .MuiSwitch-track': {
      backgroundColor: blue[500],
    },
  },
});
